import { useState } from "react";
import { useSelector } from "react-redux";
import "./newUser.css";
import { register } from "../../redux/apiCalls";
import StepCodeTag from "../../components/shared/StepCodeTag";
import PosFieldLabel from "../../components/shared/PosFieldLabel";
import { NEW_USER_STEP_CODES } from "../../constants/workflowStepCodes";

export default function NewUser() {
    const currentUser = useSelector((state) => state.user.currentUser);
    const icRequired =
        currentUser?.type === "outright" ||
        currentUser?._id === "68707e7e17b78bce728f2254";
    const [inputs, setInputs] = useState({});

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleClick = async (e) => {
        e.preventDefault();

        if (icRequired && !String(inputs.ic || "").trim()) {
            alert("Please fill in the IC / Company Registration number.");
            return;
        }

        let principleParam;
        if (currentUser?.isSuperAdmin) {
            principleParam = undefined;
        } else if (currentUser?.type === "outright") {
            principleParam = currentUser._id;
        } else {
            principleParam = currentUser?.principle;
        }

        const email = String(inputs.email || "").trim();
        const user = {
            ...inputs,
            email: email || undefined,
            principle: principleParam,
            createdBy: currentUser?._id,
        };

        try {
            register({ user });
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <div className="newProduct">
                <div className="newProductTitleRow">
                    <StepCodeTag code="A1" />
                    <h1 className="addProductTitle">New User</h1>
                </div>
                <div className="addProductForm">
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.name} className="required">
                            Name
                        </PosFieldLabel>
                        <input
                            name="name"
                            type="text"
                            placeholder="Name"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel
                            code={NEW_USER_STEP_CODES.ic}
                            className={icRequired ? "required" : undefined}
                        >
                            IC / Company Registration
                        </PosFieldLabel>
                        <input
                            name="ic"
                            type="text"
                            placeholder="IC / Company Registration Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.tin}>
                            TIN
                        </PosFieldLabel>
                        <input
                            name="tin"
                            type="text"
                            placeholder="Tax Identification Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.email}>
                            Email
                        </PosFieldLabel>
                        <input
                            name="email"
                            type="text"
                            placeholder="Email"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.phoneNumber} className="required">
                            Phone Number
                        </PosFieldLabel>
                        <input
                            name="phoneNumber"
                            type="text"
                            placeholder="Phone Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.password} className="required">
                            Password
                        </PosFieldLabel>
                        <input
                            name="password"
                            type="password"
                            placeholder="Password"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <PosFieldLabel code={NEW_USER_STEP_CODES.remarks}>
                            Remarks
                        </PosFieldLabel>
                        <textarea
                            name="remark"
                            type="text"
                            placeholder="Enter remarks"
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>
                    <button onClick={handleClick} className="updateProductButton formCreateButton new-user-create-with-tag">
                        <StepCodeTag code={NEW_USER_STEP_CODES.create} />
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}
